import type {FeatureAppDefinition} from '@feature-hub/core';
import type {ReactFeatureApp} from '@feature-hub/react';
import type {
  FeatureAppConfig,
  FeatureAppDependencies,
} from '@smart/react-utils';
import {FeatureAppEnvContext} from '@smart/react-utils';
import * as React from 'react';
import {App} from './components/app';

const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  FeatureAppDependencies,
  FeatureAppConfig
> = {
  dependencies: {
    featureServices: {
      's2:history': `^2.0.0`,
      'endpoint-directory': `^3.0.0`,
      'locale-service': `^3.0.0`,
      'payment-config-service': `^1.0.0`,
      'price-preferences-provider': `^1.0.0`,
    },
  },

  optionalDependencies: {
    featureServices: {
      's2:logger': `^1.0.0`,
      'adb-context-service': `^2.0.0`,
      'login-service': `^3.0.0`,
    },
  },

  create: (env) => ({
    render: () => (
      <FeatureAppEnvContext.Provider value={env}>
        <App />
      </FeatureAppEnvContext.Provider>
    ),
  }),
};

export default featureAppDefinition;
